export default "__VITE_ASSET__0a6a8a27__"